import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {SAVE_TUTORIAL_DATA, FETCH_TUTORIAL_DATA} from "./type";


export const saveTutorialData = (data) => async (dispatch) => {
    dispatch({ type: SAVE_TUTORIAL_DATA, payload: null });
    const res = await callWebService(
      callTypes.post,
      data,
      `${Config.postSales.saveTutorialData}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: SAVE_TUTORIAL_DATA, payload: data.response.data });
      return data.response.status;
    }
  };


  export const fetchTutorialData = (page = 1) => async (dispatch) => {
    dispatch({
        type: FETCH_TUTORIAL_DATA,
        payload: null,
    });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.postSales.fetchTutorialData}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FETCH_TUTORIAL_DATA,
            payload: data.response.data,
        });
        return true;
    }
};

